import ProductServiceContent from "./product-service-content";

export default ProductServiceContent;